// <s-announcement-rotator>: crossfades between its [data-announcement] slides every few seconds.
// Pauses while hovered or focused, and when the tab is hidden. Reduced motion swaps without the fade (CSS).
class SAnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-announcement]'));
    if (this.slides.length < 2) return;
    this.index = Math.max(0, this.slides.findIndex((slide) => slide.dataset.active === 'true'));
    this.interval = Number(this.dataset.interval) || 3500;
    this.paused = false;
    const pause = () => { this.paused = true; };
    const resume = () => { this.paused = false; };
    this.addEventListener('pointerenter', pause);
    this.addEventListener('pointerleave', resume);
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', resume);
    this.timer = setInterval(() => {
      if (!this.paused && !document.hidden) this.show(this.index + 1);
    }, this.interval);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  show(next) {
    const current = this.slides[this.index];
    this.index = (next + this.slides.length) % this.slides.length;
    const incoming = this.slides[this.index];
    current.dataset.active = 'false';
    current.setAttribute('aria-hidden', 'true');
    incoming.dataset.active = 'true';
    incoming.removeAttribute('aria-hidden');
  }
}

if (!customElements.get('s-announcement-rotator')) customElements.define('s-announcement-rotator', SAnnouncementRotator);
